import { Navigate, useSearchParams } from "react-router-dom";

/** Legacy route — redirects to the unified OAuth callback page. */
export default function SlackCallbackPage() {
  const [searchParams] = useSearchParams();
  const params = new URLSearchParams(searchParams);
  params.set("provider", "slack");
  return <Navigate to={`/oauth-callback?${params.toString()}`} replace />;
}
